/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19 12L14.5 16.5C12.567 18.433 9.433 18.433 7.5 16.5V16.5C5.567 14.567 5.567 11.433 7.5 9.5L10.7083 6.29165C11.974 5.02601 14.026 5.02601 15.2917 6.29165V6.29165C16.5243 7.52429 16.5611 9.51115 15.3749 10.7886L12.2251 14.1806C11.556 14.9013 10.4222 14.9222 9.72686 14.2269V14.2269C9.04928 13.5493 9.04928 12.4507 9.72686 11.7731L13 8.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M19 12L14.5 16.5C12.567 18.433 9.433 18.433 7.5 16.5V16.5C5.567 14.567 5.567 11.433 7.5 9.5L10.7083 6.29165C11.974 5.02601 14.026 5.02601 15.2917 6.29165V6.29165C16.5243 7.52429 16.5611 9.51115 15.3749 10.7886L12.2251 14.1806C11.556 14.9013 10.4222 14.9222 9.72686 14.2269V14.2269C9.04928 13.5493 9.04928 12.4507 9.72686 11.7731L13 8.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM11.2387 6.82198C12.2114 5.84923 13.7886 5.84923 14.7613 6.82198C15.7087 7.76937 15.737 9.29643 14.8253 10.2782L11.6756 13.6703C11.2956 14.0794 10.652 14.0913 10.2572 13.6965C9.87251 13.3118 9.87251 12.6882 10.2572 12.3035L13.5303 9.03033C13.8232 8.73744 13.8232 8.26256 13.5303 7.96967C13.2374 7.67678 12.7626 7.67678 12.4697 7.96967L9.19653 11.2428C8.22606 12.2133 8.22606 13.7867 9.19653 14.7572C10.1925 15.7532 11.8163 15.7231 12.7747 14.6909L15.9245 11.2989C17.3852 9.72587 17.3399 7.27922 15.822 5.76132C14.2634 4.20278 11.7366 4.20278 10.178 5.76132L6.96967 8.96967C4.74378 11.1956 4.74378 14.8044 6.96967 17.0303C9.19556 19.2562 12.8044 19.2562 15.0303 17.0303L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697C19.2374 11.1768 18.7626 11.1768 18.4697 11.4697L13.9697 15.9697C12.3296 17.6098 9.67043 17.6098 8.03033 15.9697C6.39023 14.3296 6.39023 11.6704 8.03033 10.0303L11.2387 6.82198Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M19 12L14.5 16.5C12.567 18.433 9.433 18.433 7.5 16.5V16.5C5.567 14.567 5.567 11.433 7.5 9.5L10.7083 6.29165C11.974 5.02601 14.026 5.02601 15.2917 6.29165V6.29165C16.5243 7.52429 16.5611 9.51115 15.3749 10.7886L12.2251 14.1806C11.556 14.9013 10.4222 14.9222 9.72686 14.2269V14.2269C9.04928 13.5493 9.04928 12.4507 9.72686 11.7731L13 8.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19 12L14.5 16.5C12.567 18.433 9.433 18.433 7.5 16.5V16.5C5.567 14.567 5.567 11.433 7.5 9.5L10.7083 6.29165C11.974 5.02601 14.026 5.02601 15.2917 6.29165V6.29165C16.5243 7.52429 16.5611 9.51115 15.3749 10.7886L12.2251 14.1806C11.556 14.9013 10.4222 14.9222 9.72686 14.2269V14.2269C9.04928 13.5493 9.04928 12.4507 9.72686 11.7731L13 8.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7614 6.82209C13.7886 5.84934 12.2115 5.84934 11.2387 6.82209L8.03037 10.0304C6.39027 11.6705 6.39027 14.3297 8.03037 15.9698C9.67047 17.6099 12.3296 17.6099 13.9697 15.9698L18.4697 11.4698C18.7626 11.1769 19.2375 11.1769 19.5304 11.4698C19.8233 11.7627 19.8233 12.2375 19.5304 12.5304L15.0304 17.0304C12.8045 19.2563 9.1956 19.2563 6.96971 17.0304C4.74382 14.8046 4.74382 11.1957 6.96971 8.96978L10.1781 5.76143C11.7366 4.20289 14.2635 4.2029 15.822 5.76143C17.3399 7.27933 17.3852 9.72598 15.9245 11.299L12.7748 14.6911C11.8164 15.7232 10.1925 15.7533 9.19657 14.7573C8.2261 13.7868 8.2261 12.2134 9.19657 11.2429L12.4697 7.96978C12.7626 7.67689 13.2375 7.67689 13.5304 7.96978C13.8233 8.26267 13.8233 8.73755 13.5304 9.03044L10.2572 12.3036C9.87255 12.6883 9.87255 13.312 10.2572 13.6966C10.652 14.0914 11.2957 14.0795 11.6756 13.6704L14.8253 10.2783C15.737 9.29654 15.7087 7.76948 14.7614 6.82209Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
